import {
  APP_MANAGED_ROUTES,
  NON_RESTORABLE_ROUTES,
  POST_LOGIN_REDIRECT_KEY,
} from 'common/app-managed-routes';

// Only ever navigate to a same-origin in-app path; reject absolute/off-origin
// values (sessionStorage is same-origin writable) and fall back to Home.
// Routes that are part of the login flow are rejected too: sending an already
// authenticated user back into them would restart it.
export const toSafeInternalPath = (candidate?: string | null): string => {
  if (candidate) {
    try {
      const url = new URL(candidate, window.location.origin);
      if (
        url.origin === window.location.origin &&
        !NON_RESTORABLE_ROUTES.includes(url.pathname)
      ) {
        return url.pathname + url.search + url.hash;
      }
    } catch {
      // malformed — fall through to Home
    }
  }
  return APP_MANAGED_ROUTES.HOME;
};

// Records the path the user tried to reach, for the landing page to restore
// after the Auth0 round trip (which only ever returns to the origin).
export const capturePostLoginRedirect = (path: string) => {
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

// Reads the attempted deep-link path and always clears it, so a stale value
// can't hijack a later login. Returns null when nothing was pending.
export const consumePostLoginRedirect = (): string | null => {
  const pendingPath = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return pendingPath;
};
